'use client'

import React from 'react'
import { BsWhatsapp } from 'react-icons/bs'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface FloatingWhatsAppButtonProps {
  phoneNumber: string
  message?: string
  ariaLabel?: string
}

const FloatingWhatsAppButton: React.FC<FloatingWhatsAppButtonProps> = ({
  phoneNumber,
  message = 'Hola! Me gustaría obtener más información.',
  ariaLabel = 'Contactar por WhatsApp'
}) => {
  const handleWhatsAppClick = () => {
    const encodedMessage = encodeURIComponent(message)
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer')
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleWhatsAppClick()
    }
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            aria-label={ariaLabel}
            tabIndex={0}
            onClick={handleWhatsAppClick}
            onKeyDown={handleKeyDown}
            className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 md:bottom-8 md:right-8 z-[1000] bg-[#25D366] text-white rounded-full w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center shadow-lg hover:bg-[#1eb155] hover:scale-110 hover:shadow-xl focus:bg-[#1eb155] focus:outline-2 focus:outline-[#25D366] focus:outline-offset-2 active:scale-95 transition-all duration-200 cursor-pointer"
          >
            <BsWhatsapp className="text-[28px] text-white" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="left">
          <p>Contactar por WhatsApp</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default FloatingWhatsAppButton 